import Loader from "react-loader-spinner";
import { faCalculator } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { getStaffPerformance_ServiceTotalCost } from "../store/api/Services";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { exportToExcel, isWebApp, keyIsLetterOrNumber } from "../../store/api/CommonFunctions";
import DatePicker from "react-datepicker2";
import BihamtaTable from "../../Components/BihamtaTable";
import { ClipboardData, FileEarmarkExcelFill, List, PrinterFill, Search } from "react-bootstrap-icons";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import ModalSelectStaff from "../../Components/Modals/ModalSelectStaff";

const StaffPerformanceTotalCostReport = () => {

    const history = useHistory();
    const dispatch = useDispatch();
    const { filterData } = useSelector(state => { return { filterData: state.service.srvTotalCostFilters } });
    const { register, handleSubmit } = useForm();
    const [dateFilters, setDateFilters] = useState({});
    const [pending, setPending] = useState(false);
    const [popStaff, setPopStaff] = useState({ show: false });
    const [selectedStaff, setStaffData] = useState(null);
    const settingNames = ['ProductGrouppingType'];
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف", showInMobile: true },
        { colName: "StaffName", colTitle: "تکنسین", showInMobile: true },
        // { colName: "PServiceType", colTitle: "نوع سرویس", showInMobile: true },
        { colName: "ServiceCount", colTitle: "تعداد سرویس", showInMobile: true },
        { colName: "CashPayment", colTitle: "دریافت صندوق", colType: "currency" },
        { colName: "BankPayment", colTitle: "دریافت بانک", colType: "currency" },
        { colName: "GuaranteeUsedParts", colTitle: "قطعات گارانتی", colType: "currency" },
        { colName: "NonGuaranteeUsedParts", colTitle: "قطعات آزاد", colType: "currency" },
        { colName: "GuaranteeDefindes", colTitle: "تعرفه های گارانتی", colType: "currency" },
        { colName: "NonGuaranteeDefindes", colTitle: "تعرفه های آزاد", colType: "currency" },
        { colName: "GuaranteeExtras", colTitle: "سایر خدمات گارانتی", colType: "currency" },
        { colName: "NonGuaranteeExtras", colTitle: "سایر خدمات آزاد", colType: "currency" },
        { colName: "TotalServiceCost", colTitle: "مجموع خدمات", colType: "currency" },
        { colName: "TotalUsedParts", colTitle: "مجموع قطعات", colType: "currency" },
        { colName: "ReferralsCount", colTitle: "تعداد مراجعه", colType: "currency" },
        { colName: "Referrals", colTitle: "ایاب و ذهاب", colType: "currency" },
        { colName: "StaffShare", colTitle: "سهم تکنسین", colType: "currency" },
        // {colName:"DurationName", colTitle:"دوره مالی"}
    ]
    function search(data) {
        const dateFrom = document.getElementsByName("DateFrom")[0].value;
        if (dateFrom !== "") {
            data.ContactDateFrom = dateFilters.DateFrom;
            data.PContactDateFrom = dateFrom;
        }
        const dateTo = document.getElementsByName("DateTo")[0].value;
        if (dateTo !== "") {
            data.ContactDateTo = dateFilters.DateTo;
            data.PContactDateTo = dateTo;
        }
        const refDateFrom = document.getElementsByName("LastRefDateFrom")[0].value;
        if (refDateFrom !== "") {
            data.LastRefDateFrom = dateFilters.LastRefDateFrom;
            data.PLastRefDateFrom = refDateFrom;
        }
        const refDateTo = document.getElementsByName("LastRefDateTo")[0].value;
        if (refDateTo !== "") {
            data.LastRefDateTo = dateFilters.LastRefDateTo;
            data.PLastRefDateTo = refDateTo;
        }
        const archiveDateFrom = document.getElementsByName("ArchiveDateFrom")[0].value;
        if (archiveDateFrom !== "") {
            data.ArchiveDateFrom = dateFilters.ArchiveDateFrom;
            data.PArchiveDateFrom = archiveDateFrom;
        }
        const archiveDateTo = document.getElementsByName("ArchiveDateTo")[0].value;
        if (archiveDateTo !== "") {
            data.ArchiveDateTo = dateFilters.ArchiveDateTo;
            data.PArchiveDateTo = archiveDateTo;
        }        
        data.Skip = 0;
        data.StaffID = selectedStaff?.ID;
        dispatch(getStaffPerformance_ServiceTotalCost(data));

    }
    function toExcel() {
        const url = `api/ServiceReportsAPI/GetStaffPerformance_ServiceTotalCost`;
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        searchArgs.Skip = 0;
        setPending(true);
        exportToExcel("StaffPerformanceServiceTotalCost", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function printReport(e) {
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        searchArgs.Skip = 0;
        history.push({
            pathname: `/PrintViewer/StaffPerformanceServiceTotalCost/${e.ctrlKey}`,
            state: {
                dataUrl: `api/ServiceReportsAPI/GetStaffPerformance_ServiceTotalCost`,
                method: "post",
                fetchBody: JSON.stringify(searchArgs)
            }
        });
    }
    function showList(row) {
        history.push(`/Services/StaffPerformanceServiceCostList/${row.StaffID}`);
    }
    function showModalStaff(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelect = (data) => {
            setStaffData(data);
        }
        setPopStaff({ show: true, onSelect: onSelect });
    }
    useEffect(() => {
        dispatch(getSystemSettings(settingNames));
        document.body.classList = "notMain";
        document.title = "بی همتا-خدمات";
    }, [])
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card>
                <ModalSelectStaff popData={popStaff} setPopSelectStaff={setPopStaff} />
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faCalculator} size="lg" />&nbsp;
                    گزارش عملکرد تکنسین(مجموع ریالی)
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <form onSubmit={handleSubmit(search)}>
                        <Row className="rowBorder">
                            <Col md={2} className="form-group">
                                <label>تاریخ پذیرش از: </label>
                                <DatePicker className="form-control" timePicker={false} isGregorian={false} name="DateFrom" onChange={val => dateFilters.DateFrom = val.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ پذیرش تا: </label>
                                <DatePicker className="form-control" timePicker={false} isGregorian={false} name="DateTo" onChange={val => dateFilters.DateTo = val.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ انجام از: </label>
                                <DatePicker className="form-control" timePicker={false} isGregorian={false} name="LastRefDateFrom" onChange={val => dateFilters.LastRefDateFrom = val.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ انجام تا: </label>
                                <DatePicker className="form-control" timePicker={false} isGregorian={false} name="LastRefDateTo" onChange={val => dateFilters.LastRefDateTo = val.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ بایگانی از: </label>
                                <DatePicker className="form-control" timePicker={false} isGregorian={false} name="ArchiveDateFrom"
                                    onChange={val => dateFilters.ArchiveDateFrom = val.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ بایگانی تا: </label>
                                <DatePicker className="form-control" timePicker={false} isGregorian={false} name="ArchiveDateTo"
                                    onChange={val => dateFilters.ArchiveDateTo = val.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>مشخصات تکنسین: </label>
                                <Form.Control readOnly value={selectedStaff?.LastName ?? ""} onKeyDown={showModalStaff} />
                                <Button className="btn-input-tiny" onClick={showModalStaff} style={{ marginTop: "-1px" }}><List size={20} /></Button>
                            </Col>
                        </Row>
                        <Button type="submit" className="mt-1 group-Btn-large"><ClipboardData size={18} />&nbsp; خروجی گزارش </Button>
                    </form>
                    {!pending &&
                        <div style={{ padding: 1, width: "100%", textAlign: "left", marginTop: "5px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                            <PrinterFill color="blue" size={25} style={{ cursor: "pointer" }} className="hoverIcon" onClick={printReport} />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable columns={tableCols} reducerName="service" searchMethod={(data) => dispatch(getStaffPerformance_ServiceTotalCost(data))}
                        objectName="srvTotalCostReport" filterData={filterData} maxHeight={500} className="mt-0 mb-0" style={{ whiteSpace: "nowrap" }} rowClick={showList} />
                    {isWebApp() &&
                        <div className="mt-3" style={{ color: "blue", textAlign: "left" }}>
                            برای نمایش ریز عملکرد روی ردیف مورد نظر کلیک کنید
                        </div>
                    }
                </Card.Body>
            </Card>
        </div>)
}
export default StaffPerformanceTotalCostReport;